import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { TimeZoneOption } from '../models/time-zone-option';
import { timeZoneOptionActions } from '../state/time-zone-option.actions';
import { timeZoneOptionSelectors } from '../state/time-zone-option.reducer';

@Directive({
    selector: '[ndtTimeZoneSelect]',
    standalone: false
})
export class TimeZoneSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<TimeZoneOption>,
      private statusService: NgrxEagerSelectService<AppState, TimeZoneOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      if (this.accountId) {
         staticFilterOverride = [`AccountId = ${this.accountId}`];
      }

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            timeZoneOptionActions,
            timeZoneOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('timeZoneId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
